import React from "react";
import { Avatar } from "primereact/avatar";
import { Timeline } from "primereact/timeline";
import PrimaryButton from "./CustomButtons";
import { Link } from "react-router-dom";
// import placeholderImg from "../../assets/images/placeholder-img.png";
import CustomImage from "./CustomImage";
import constants from "../../constants";
import { getImageUrl } from "../../utils/commonFunctions";

const BASE_URL = constants.endPointUrl
export default function CustomCard({
  key,
  extraClass,
  src,
  title,
  detail,
  width,
  iconClass,
  order
}) {
  return (
    <div key={key} className={`cursor-pointer service-box p-4 ${extraClass}`}>
      {src ? (
        <img src={src} alt={title} className="mb-3" width={width} />
      ) : null}
      {order ? (
        <div className={`number-box flex align-items-center justify-content-center text-white mb-3 font-bold ${iconClass}`}>
          {order}
        </div>
      ) : null}
      {title ? <h3 className="mt-2 text-2xl font-semibold">{title}</h3> : null}
      {detail ? (
        <p className="text-base text-gray-color mt-2">{detail}</p>
      ) : null}
    </div>
  );
}

export const TestimonialCard = ({
  src,
  title,
  detail,
  clientName,
  designation,
}) => {
  return (
    <div className="p-3 testimonial-card h-full">
      <h2 className="heading text-lg font-semibold">{title}</h2>
      <p className="text-gray-color text-base">{detail}</p>
      <div className="flex align-items-center gap-3">
        <Avatar image={getImageUrl(src)} size="large" shape="circle" />
        <div>
          <h4 className="heading font-semibold m-0 mb-1">{clientName}</h4>
          <p className="text-sm text-gray-color m-0">{designation}</p>
        </div>
      </div>
    </div>
  );
};

export const CardBox = ({ extraClass, children, style }) => {
  return (
    <div
      className={`cursor-pointer border-round-xl shadow-1 p-4 ${extraClass}`}
      style={style}
    >
      {children}
    </div>
  );
};

// export const OrderCard = ({
//   extraClass,
//   orderid,
//   src,
//   type,
//   to,
//   placedon,
//   total,
//   projectname,
//   quantity,
//   timeline,
//   style,
// }) => {
//   const customizedMarker = (item) => {
//     return (
//         <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1" style={{ backgroundColor: item.color }}>
//             <i className={item.icon}></i>
//         </span>
//     );
// };

// const customizedContent = (item) => {
//     return (
//         <Card title={item.status} subTitle={item.date}>
//             { item.image && <img src={`https://primefaces.org/cdn/primereact/images/product/${item.image}`} alt={item.name} width={200} className="shadow-1" />}
//             <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt
//                 quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!</p>
//             <Button label="Read more" className="p-button-text"></Button>
//         </Card>
//     );
// };
//   return (
//     <div
//       className={`cursor-pointer order-card border-round-xl shadow-1 p-4 ${extraClass}`}
//       style={style}
//     >
//       <h3 className="flex gap-3">
//         Order ID: <span className="primary-color">{orderid}</span>
//       </h3>
//       <div className="md:flex gap-3 justify-content-between align-items-start">
//         <div className="md:flex gap-4 ">
//           <div className="order-image">
//             <img src={src} alt="" className="w-full h-full border-round-xl " />
//           </div>
//           <div className="grid">
//             <div className="col-6 lg:col-4">
//               <p className="font-bold my-2">Project Type</p>
//               <p className="text-gray-color m-0">{type}</p>
//             </div>
//             <div className="col-6 lg:col-4">
//               <p className="font-bold my-2">Placed on</p>
//               <p className="text-gray-color m-0">{placedon}</p>
//             </div>
//             <div className="col-6 lg:col-4">
//               <p className="font-bold my-2">Total</p>
//               <p className="text-gray-color m-0">{total}</p>
//             </div>
//             <div className="col-6 lg:col-4">
//               <p className="font-bold my-2">Project Name</p>
//               <p className="text-gray-color m-0">{projectname}</p>
//             </div>
//             <div className="col-6 lg:col-4">
//               <p className="font-bold my-2">Quantity</p>
//               <p className="text-gray-color m-0">{quantity}</p>
//             </div>
//           </div>
//         </div>

//         <div className="">
//           <p className="fonr-bold mt-0">Status</p>
//           {/* <Timeline
//             value={timeline}
//             className="align-items-start timeline-styled"
//             content={(item) => (
//               <div
//                 className={`p-timeline-event ${item.active ? "active" : ""
//                   } timeline-item`}
//               >
//                 <small className={item.active ? "primary-color" : ""}>
//                   {item.status}
//                 </small>
//               </div>
//             )}
//           /> */}
//

//         </div>
//         <div className="">
//           <Link to={to}>
//             <PrimaryButton extraClassNames="w-auto" label="Order Details" />
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

export const OrderCard = ({
  extraClass,
  orderid,
  src,
  type,
  to,
  placedOn,
  total,
  projectname,
  quantity,
  timeline,
  style,
}) => {
  const customizedMarker = (item) => {
    return (
      <span
        className={`flex list-icon-order align-items-center justify-content-center text-white border-circle z-1 shadow-1 ${item.active ? "active" : ""
          }`}
        style={{ backgroundColor: item.color }}
      >
        <i className={item.icon}></i>
      </span>
    );
  };

  const customizedContent = (item) => {
    return (
      <>
        <div
          className={`p-timeline-event ${item.active ? "active" : ""
            } timeline-item`}
        >
          <small className={item.active ? "primary-color" : ""}>
            {item.status}
          </small>
        </div>
      </>
    );
  };

  return (
    <div
      className={`cursor-pointer order-card border-round-xl shadow-1 p-4 ${extraClass}`}
      style={style}
    >
      <h3 className="flex gap-3">
        Order ID: <span className="primary-color">{orderid}</span>
      </h3>
      <div className="md:flex gap-3 justify-content-between align-items-start">
        <div className="md:flex gap-4">
          <div className="order-image">
            <CustomImage src={src} className="w-full h-full border-round-xl" />
          </div>
          <div className="grid">
            <div className="col-6 lg:col-4">
              <p className="font-bold my-2">Project Type</p>
              <p className="text-gray-color m-0">{type}</p>
            </div>
            <div className="col-6 lg:col-4">
              <p className="font-bold my-2">Placed on</p>
              <p className="text-gray-color m-0">{placedOn}</p>
            </div>
            <div className="col-6 lg:col-4">
              <p className="font-bold my-2">Total</p>
              <p className="text-gray-color m-0">{total}</p>
            </div>
            <div className="col-6 lg:col-4">
              <p className="font-bold my-2">Project Name</p>
              <p className="text-gray-color m-0">{projectname}</p>
            </div>
            <div className="col-6 lg:col-4">
              <p className="font-bold my-2">Quantity</p>
              <p className="text-gray-color m-0">{quantity}</p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap">
          <div>
            <p className="font-bold mt-0">Status</p>
            <Timeline
              value={timeline}
              className="align-items-start timeline-styled"
              marker={customizedMarker}
              content={customizedContent}
            />
          </div>
          <Link to={to}>
            <PrimaryButton extraClassNames="w-auto" label="Order Details" />
          </Link>
        </div>
      </div>
    </div>
  );
};
